import { FC } from "react";
import cx from "classnames";

import styles from "./TMXPhaseCard.module.scss";
import classNames from "classnames";

export type Item = {
  id: number;
  title?: string;
  content?: JSX.Element;
  footerTitle?: string;
  isCompleted?: boolean;
};

type Props = {
  item: Item;
  setCurrentPhase: (id: number) => void;
  isActive: Boolean;
};

const TMXPhaseCard: FC<Props> = ({ item, setCurrentPhase, isActive }) => {
  return (
    <div
      className={cx(styles.wrapper, {
        [styles.active]: isActive,
      })}
      onClick={() => setCurrentPhase(item.id)}
    >
      <h2 className={styles.title}>{item.title}</h2>

      <div className={styles.textWrapper}>{item.content}</div>

      <div
        className={classNames(styles.footer, {
          [styles.comingSoonFooter]: !item.isCompleted,
        })}
      >
        {item.isCompleted ? (
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M11.9984 21.6004C17.3003 21.6004 21.5984 17.3023 21.5984 12.0004C21.5984 6.69846 17.3003 2.40039 11.9984 2.40039C6.69651 2.40039 2.39844 6.69846 2.39844 12.0004C2.39844 17.3023 6.69651 21.6004 11.9984 21.6004ZM16.4469 10.4489C16.9155 9.98029 16.9155 9.22049 16.4469 8.75186C15.9783 8.28323 15.2185 8.28323 14.7499 8.75186L10.7984 12.7033L9.24697 11.1519C8.77834 10.6832 8.01854 10.6832 7.54991 11.1519C7.08128 11.6205 7.08128 12.3803 7.54991 12.8489L9.94991 15.2489C10.4185 15.7175 11.1783 15.7175 11.6469 15.2489L16.4469 10.4489Z"
              fill="white"
            />
          </svg>
        ) : (
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M11.9984 21.6004C17.3003 21.6004 21.5984 17.3023 21.5984 12.0004C21.5984 6.69846 17.3003 2.40039 11.9984 2.40039C6.69651 2.40039 2.39844 6.69846 2.39844 12.0004C2.39844 17.3023 6.69651 21.6004 11.9984 21.6004ZM9.05176 8.95176C9.52039 8.48313 10.2802 8.48313 10.7488 8.95176L11.9984 10.2013L13.248 8.95176C13.7166 8.48313 14.4764 8.48313 14.945 8.95176C15.4136 9.42039 15.4136 10.1802 14.945 10.6488L13.6954 11.8984L14.945 13.148C15.4136 13.6166 15.4136 14.3764 14.945 14.845C14.4764 15.3136 13.7166 15.3136 13.248 14.845L11.9984 13.5954L10.7488 14.845C10.2802 15.3136 9.52039 15.3136 9.05176 14.845C8.58313 14.3764 8.58313 13.6166 9.05176 13.148L10.3013 11.8984L9.05176 10.6488C8.58313 10.1802 8.58313 9.42039 9.05176 8.95176Z"
              fill="white"
            />
          </svg>
        )}

        <span className={styles.footerTitle}>{item.footerTitle}</span>
        <span className={styles.footerCompleted}>{item.isCompleted ? "Completed" : "Coming Soon"}</span>
      </div>
    </div>
  );
};

export default TMXPhaseCard;
